export enum DateRangeEnum {
  OneDay = '1 day',
  ThreeDays = '3 days',
  SevenDays = '7 days',
  FourteenDays = '14 days',
  ThirtyDays = '30 days',
}

export const DATE_RANGE_OPTIONS = [
  { key: DateRangeEnum.OneDay, days: 1 },
  { key: DateRangeEnum.ThreeDays, days: 3 },
  { key: DateRangeEnum.SevenDays, days: 7 },
  { key: DateRangeEnum.FourteenDays, days: 14 },
  { key: DateRangeEnum.ThirtyDays, days: 30 },
] as const
